module.exports = __webpack_public_path__ + "static/media/055-scotland.d9d94adf.svg";